import { Button, EButtonColor, Section, SectionSubtitle, SectionTitle } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import ENV from '../../base/env';
import './FBPromotionSection.scss';

const FBPromotionSection: React.FC = () => {
  const { t } = useTranslation();

  const title = t('common:FBPromotion.Title');
  const description = t('common:FBPromotion.Description');
  const imgSrc = `${ENV.AssetsBaseUrl}/feature/community_1.png`;
  return (
    <Section className="fb-promotion-banner">
      <SectionTitle className="fb-promotion-banner-title">{title}</SectionTitle>
      <div className="row fb-promotion-banner-row">
        <div className="col-2 col-m-4">
          <img className="fb-promotion-banner-image" alt={title} src={imgSrc} />
        </div>
        <div className="col-10 col-m-4">
          <SectionSubtitle className="fb-promotion-banner-description">{description}</SectionSubtitle>
          <a href={ENV.FBGroupUrl}>
            <Button color={EButtonColor.white} label={t('common:FBPromotion.Button')} />
          </a>
        </div>
      </div>
    </Section>
  );
};

export default FBPromotionSection;
